(() => {
  const triggers = document.querySelectorAll(".promo-banner");
  if (!triggers.length) return;

  const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  triggers.forEach((trigger) => {
    const modalId = trigger.getAttribute("aria-controls");
    if (!modalId) return;

    const modal = document.getElementById(modalId);
    if (!modal) return;

    const closeBtn = modal.querySelector("[data-close]");

    const open = () => {
      if (typeof modal.showModal === "function") modal.showModal();
      else modal.setAttribute("open", "");

      // Allow browser to paint "closed" state, then animate in
      modal.classList.remove("is-active");
      requestAnimationFrame(() => {
        if (!prefersReduced) modal.classList.add("is-active");
        else modal.classList.add("is-active");
      });
    };

    const close = () => {
      // Animate out first, then close the dialog
      modal.classList.remove("is-active");

      const finish = () => {
        modal.removeEventListener("transitionend", onEnd);
        if (typeof modal.close === "function") modal.close();
        else modal.removeAttribute("open");
      };

      const onEnd = (e) => {
        if (e.target === modal) finish();
      };

      // If reduced motion, close immediately
      if (prefersReduced) return finish();

      modal.addEventListener("transitionend", onEnd);
      // Fallback in case transitionend doesn't fire
      setTimeout(finish, 420);
    };

    trigger.addEventListener("click", open);
    closeBtn && closeBtn.addEventListener("click", close);

    // Backdrop click closes
    modal.addEventListener("click", (e) => {
      if (e.target === modal) close();
    });

    // ESC closes with animation
    modal.addEventListener("cancel", (e) => {
      e.preventDefault();
      close();
    });
  });
})();
